export enum UploadStatus {
  READY,
  PROGRESSING,
  SUCCESS,
  FAIL
}
